import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';
import {EffectsModule} from '@ngrx/effects';
import {StoreModule} from '@ngrx/store';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTableModule } from '@angular/material/table';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import {CoreModule} from '@core/core.module';

import {SharedModule} from '@shared/shared.module';
import {CdkTableModule} from '@angular/cdk/table';
import {FormsModule} from '@angular/forms';
import {taskManagerReducer} from './store/task-manager.reducer';
import {TaskManagerEffect} from './store/task-manager.effects';
import {taskManagerRoutes} from './task-manager.routes';
import {TaskDetailComponent} from './components/task-detail/task-detail.component';
import {TaskManagerContentComponent} from './components/task-manager-content/task-manager.component';
import {TaskManagerDynamicComponentHelper} from './task-manager-dynamic-component-helper';
import {TaskAttachmentsComponent} from './components/task-attachments/task-attachments.component';
import {TaskManagementDetailComponent} from './components/task-management-detail/task-management-detail.component';
import {CompanyInfoComponent} from './components/company-info/company-info.component';
import {TaskManagerMyTicketListComponent} from './components/task-manager-my-ticket-list/task-manager-my-ticket-list.component';
import {ComapanyTicketsComponent} from './components/comapany-tickets/comapany-tickets.component';
import {TaskAssigneeComponent} from './components/task-assignee/task-assignee.component';
import {TaskAlertComponent} from './components/task-alert/task-alert.component';
import {TaskSelectorComponent} from './components/task-selector/task-selector.component';
import {AddBoardDialogComponent} from './components/add-board-dialog/add-board-dialog.component';
import {TaskManagerTicketListComponent} from './components/task-manager-ticket-list/task-manager-ticket-list.component';
import {TaskManagerBoardListComponent} from './components/task-manager-board-list/task-manager-board-list.component';
import {TaskManagerBoardTileComponent} from './components/task-manager-board-tile/task-manager-board-tile.component';
import {TaskManagerKanbanComponent} from './components/task-manager-kanban/task-manager-kanban.component';
import {TaskManagerPersonalKanbanComponent} from './components/task-manager-kanban/task-manager-personal-kanban-component';
import {TaskManagerSupportKanbanComponent} from './components/task-manager-kanban/task-manager-support-kanban-component';
import {TaskManagerPersonalListComponent} from './components/task-manager-ticket-list/task-manager-personal-list-component';
import {TaskManagerSupportListComponent} from './components/task-manager-ticket-list/task-manager-support-list-component';
import {TaskChecklistComponent} from './components/task-checklist/task-checklist.component';
import {TaskSubTicketsComponent} from './components/task-sub-tickets/task-sub-tickets.component';
import {TaskTitleComponent} from './components/task-title/task-title.component';
import {TaskOccurrenceComponent} from './components/task-occurrence/task-occurrence.component';
import {TaskChecklistItemAttachmentComponent} from './components/task-checklist-item-attachment/task-checklist-item-attachment.component';
import {TaskCommentComponent} from './components/task-comment/task-comment.component';
import {AddColumnDialogComponent} from './components/add-column-dialog/add-column-dialog.component';
import {TaskCellViewerComponent} from './components/cell-viewers/task-cell-viewer/task-cell-viewer.component';
import {AddLinkDialogComponent} from './components/add-link-dialog/add-link-dialog.component';
import {CollaborationReducer} from './collaboration/store/collaboration.reducer';
import {CollaborationEffects} from './collaboration/store/collaboration.effects';
import {CollaborationDynamicComponentHelper} from './collaboration/collaboration-dynamic-component-helper';
import {SupportChatComponent} from './collaboration/components/support-chat/support-chat.component';
import {HelpSupportComponent} from './collaboration/components/help-support/help-support.component';
import {WaitingSupportConversationListComponent} from './collaboration/components/waiting-support-conversation-list/waiting-support-conversation-list.component';
import {CollaborationConversationListComponent} from './collaboration/components/collaboration-conversation-list/collaboration-conversation-list.component';
import {ChatComponent} from './collaboration/components/conversation-dialog/chat.component';
import {FieldConversationComponent} from './collaboration/components/field-conversation/field-conversation.component';
import {ChatViewsModule} from './collaboration/chat-views.module';
import {NewConversationComponent} from './collaboration/components/new-conversation/new-conversation.component';
import {SpeechWithActionComponent} from './collaboration/components/support-chat/speech-with-action/speech-with-action.component';
import {CollaborationContentComponent} from './collaboration/components/collaboration-content/collaboration-content.component';
import {StartDemoComponent} from './components/start-demo/start-demo.component';
import {EndDemoComponent} from './components/end-demo/end-demo.component';
import {StatusSettingsDialogComponent} from './components/status-settings-dialog/status-settings-dialog.component';
import {CommentDialogComponent} from './collaboration/components/comment-dialog/comment-dialog.component';
import {SupportCommentDialogComponent} from './collaboration/components/comment-dialog/support-comment-dialog.component';
import {AddContactDialogComponent} from './collaboration/components/add-contact-dialog/add-contact-dialog.component';
import {EditConversationListComponent} from './collaboration/components/edit-conversation-list/edit-conversation-list.component';
import {DeleteConversationsDialogComponent} from './collaboration/components/delete-conversations-dialog/delete-conversations-dialog.component';
import {ConversationAddContactComponent} from './collaboration/components/conversation-add-contact/conversation-add-contact.component';
import {ChatSettingsDialogComponent} from './collaboration/components/chat-settings-dialog/chat-settings-dialog.component';
import {TaskNotificationStatusCellViewerComponent} from './components/task-notification-status-cell-viewer/task-notification-status-cell-viewer.component';
import {HelpNotesComponent} from './collaboration/components/help-notes/help-notes.component';
import {SnippetComponent} from './collaboration/components/snippet/snippet.component';
import {TaskAutoCreateCellViewerComponent} from './components/cell-viewers/task-auto-create-cell-viewer/task-auto-create-cell-viewer.component';
import {TaskAlertSendNotificationNowGridComponent} from './components/task-alert-send-notification-now-grid/task-alert-send-notification-now-grid.component';
import {ActivitiesComponent} from './collaboration/components/ActivityTracker/activities/activities.component';
import {ActivityFeedComponent} from './collaboration/components/ActivityTracker/activity-feed/activity-feed.component';
import {ActivityComponent} from './collaboration/components/ActivityTracker/activity/activity.component';
import {ActivityTrackerHandler} from './services/activity-tracker.handler';
import {ActivityTrackerFilterComponent} from './collaboration/components/ActivityTracker/activity-tracker-filter/activity-tracker-filter.component';
import {PlatformReportsHandler} from './services/platform-reports.handler';
import {CommandService} from '@core/services/command.service';
import {PlatformCommand} from '@shared/commands/command-base';
import { ActivityFilterCountrySelectorComponent } from './collaboration/components/ActivityTracker/selector-dialogs/activity-filter-country-selector/activity-filter-country-selector.component';
import { ActivityFilterEntitySelectorComponent } from './collaboration/components/ActivityTracker/selector-dialogs/activity-filter-entity-selector/activity-filter-entity-selector.component';
import { ActivityFilterProjectSelectorComponent } from './collaboration/components/ActivityTracker/selector-dialogs/activity-filter-project-selector/activity-filter-project-selector.component';
import { ActivityFilterTransactionsSelectorComponent } from './collaboration/components/ActivityTracker/selector-dialogs/activity-filter-transactions-selector/activity-filter-transactions-selector.component';
import { ActivityFilterCaseSelectorComponent } from './collaboration/components/ActivityTracker/selector-dialogs/activity-filter-case-selector/activity-filter-case-selector.component';
import {ActivityTrackerViewHandler} from './services/activity-tracker-view.handler';
import { ActivityFilterDateRangeSelectorComponent } from './collaboration/components/ActivityTracker/selector-dialogs/activity-filter-date-range-selector/activity-filter-date-range-selector.component';
import {UsageReportHandler} from './services/usage-report.handler';
import {ShowSelfRegisteredEatUsageReportHandler} from './services/show-self-registered-eat-usage-report-handler';
import {OpenTaskCommandHandler} from './services/open-task-command-handler';
import {UsageReportByArticleHandler} from './services/usage-report-by-article.handler';
import { FuseSharedModule } from '@barebone-fuse/@fuse/shared.module';
import { FuseSearchBarModule } from '@barebone-fuse/@fuse/components';
import {TaskRoleComponent} from '@features/task-manager/components/task-role/task-role.component';
import { ReferenceNotificationSettingsComponent } from './collaboration/components/ActivityTracker/reference-notification-settings/reference-notification-settings.component';
import { TaskComponent } from './components/task/task.component';
import { TaskHeaderComponent } from './components/task-header/task-header.component';
import { TaskBodyComponent } from './components/task-body/task-body.component';
import { TaskToolbarComponent } from './components/task-toolbar/task-toolbar.component';
import { TaskBodyDefaultViewComponent } from './components/task-body-default-view/task-body-default-view.component';
import { TaskDetailViewComponent } from './components/task-detail-view/task-detail-view.component';
import { TaskViewRightBarComponent } from './components/task-view-right-bar/task-view-right-bar.component';
import { TaskConnectionHistoryComponent } from './components/task-connection-history/task-connection-history.component';
import { TaskSubTicketViewComponent } from './components/task-sub-ticket-view/task-sub-ticket-view.component';
import { TaskDescriptionComponent } from './components/task-description/task-description.component';
import { ReactionTooltipComponent } from './collaboration/components/reaction-tooltip/reaction-tooltip.component';
import {DemoConfigFilterCommandHandler} from '@features/task-manager/services/demo-config-filter-command-handler';
import {Api} from '@shared/constants/common-field.constants';
import {SupportOrbitaxHandler} from '@features/task-manager/services/support-orbitax.handler';
import { DumpDemoDataComponent } from './components/dump-demo-data/dump-demo-data.component';
import { DueDateTaskReturnDetailsViewComponent } from './components/due-date-task-return-details-view/due-date-task-return-details-view.component';
import {SharedPipesModule} from '@shared/shared-pipes.module';
import { MagicBarConversationComponent } from './collaboration/components/magic-bar-conversation/magic-bar-conversation.component';
import {AdminPanelDynamicComponentHelper} from '@features/admin-panel/admin-panel-dynamic-component-helper';
import {VirtualGridTileIconViewComponent} from '@shared/components/virtual-grid-tile-icon-view/virtual-grid-tile-icon-view.component';
import {XatbotArticleCellViewerComponent} from "@features/task-manager/components/xatbot-article-cell-viewer/xatbot-article-cell-viewer.component";
import { SupportResolutionComponent } from '@features/support/components/support-resolution/support-resolution.component';
import { QuillModule } from 'ngx-quill';
import {DataTracingModule} from "@features/data-tracing/data-tracing.module";
import {DataSourcesRootComponent} from "@features/data-tracing/components/data-sources-root/data-sources-root.component";
import {ContactsModule} from '@features/contacts/contacts.module';
import { ActivityCardsComponent } from './collaboration/components/ActivityTracker/activity-cards/activity-cards.component';
import {DragDropModule} from "@angular/cdk/drag-drop";
import { MentionedActivitiesComponent } from './collaboration/components/ActivityTracker/mentioned-activities/mentioned-activities.component';
import { ActivityGotoResolverComponent } from './collaboration/components/ActivityTracker/activity-goto-resolver/activity-goto-resolver.component';
import { DndToggleComponent } from '@features/calls/dnd-toggle/dnd-toggle.component';
import { CallCardComponent } from '@features/calls/call-card/call-card.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild(taskManagerRoutes),
    EffectsModule.forFeature([TaskManagerEffect]),
    StoreModule.forFeature('task-manager', taskManagerReducer),
    CdkTableModule,
    DragDropModule,
    MatSidenavModule,
    MatButtonModule,
    MatIconModule,
    MatToolbarModule,
    MatCheckboxModule,
    MatFormFieldModule,
    MatInputModule,
    MatStepperModule,
    FuseSharedModule,
    FuseSearchBarModule,
    MatMenuModule,
    MatButtonToggleModule,
    MatSelectModule,
    MatDividerModule,
    MatTableModule,
    MatPaginatorModule,
    MatDatepickerModule,
    MatProgressSpinnerModule,
    FormsModule,
    MatTooltipModule,
    SharedModule,
    StoreModule.forFeature('collaboration', CollaborationReducer),
    EffectsModule.forFeature([CollaborationEffects]),
    CoreModule,
    SharedPipesModule,
    QuillModule.forRoot(),
    DataTracingModule,
    ContactsModule,
    ChatViewsModule,
    DndToggleComponent,
    CallCardComponent
  ],
  declarations: [
    DataSourcesRootComponent,
    AddContactDialogComponent,
    TaskDetailComponent,
    TaskDetailViewComponent,
    TaskManagerContentComponent,
    TaskAttachmentsComponent,
    TaskManagementDetailComponent,
    CompanyInfoComponent,
    TaskManagerMyTicketListComponent,
    ComapanyTicketsComponent,
    TaskAssigneeComponent,
    TaskRoleComponent,
    TaskAlertComponent,
    TaskSelectorComponent,
    AddBoardDialogComponent,
    TaskManagerSupportListComponent,
    TaskManagerTicketListComponent,
    TaskManagerBoardListComponent,
    TaskManagerBoardTileComponent,
    TaskManagerKanbanComponent,
    TaskManagerPersonalKanbanComponent,
    TaskManagerSupportKanbanComponent,
    TaskManagerPersonalListComponent,
    TaskChecklistComponent,
    TaskSubTicketsComponent,
    TaskTitleComponent,
    TaskOccurrenceComponent,
    TaskChecklistItemAttachmentComponent,
    TaskCommentComponent,
    AddColumnDialogComponent,
    TaskCellViewerComponent,
    AddLinkDialogComponent,
    CollaborationContentComponent,
    NewConversationComponent,
    MagicBarConversationComponent,
    FieldConversationComponent,
    ChatComponent,
    CollaborationConversationListComponent,
    WaitingSupportConversationListComponent,
    HelpSupportComponent,
    SupportChatComponent,
    SpeechWithActionComponent,
    StartDemoComponent,
    EndDemoComponent,
    StatusSettingsDialogComponent,
    CommentDialogComponent,
    SupportCommentDialogComponent,
    EditConversationListComponent,
    DeleteConversationsDialogComponent,
    ConversationAddContactComponent,
    ChatSettingsDialogComponent,
    TaskNotificationStatusCellViewerComponent,
    HelpNotesComponent,
    SnippetComponent,
    TaskAutoCreateCellViewerComponent,
    TaskAlertSendNotificationNowGridComponent,
    ActivitiesComponent,
    ActivityFeedComponent,
    ActivityComponent,
    ActivityTrackerFilterComponent,
    ActivityFilterCountrySelectorComponent,
    ActivityFilterEntitySelectorComponent,
    ActivityFilterProjectSelectorComponent,
    ActivityFilterTransactionsSelectorComponent,
    ActivityFilterCaseSelectorComponent,
    ActivityFilterDateRangeSelectorComponent,
    ReferenceNotificationSettingsComponent,
    TaskComponent,
    TaskHeaderComponent,
    TaskBodyComponent,
    TaskToolbarComponent,
    TaskBodyDefaultViewComponent,
    TaskViewRightBarComponent,
    TaskConnectionHistoryComponent,
    TaskSubTicketViewComponent,
    TaskDescriptionComponent,
    ReactionTooltipComponent,
    DumpDemoDataComponent,
    DueDateTaskReturnDetailsViewComponent,
    XatbotArticleCellViewerComponent,
    SupportResolutionComponent,
    ActivityCardsComponent,
    MentionedActivitiesComponent,
    ActivityGotoResolverComponent
  ],
  exports: [
    ChatViewsModule,
    DataSourcesRootComponent,
    MagicBarConversationComponent,
    ReactionTooltipComponent,
    TaskDetailComponent,
    TaskDetailViewComponent,
    TaskManagerContentComponent,
    TaskAttachmentsComponent,
    TaskManagementDetailComponent,
    CompanyInfoComponent,
    TaskManagerMyTicketListComponent,
    ComapanyTicketsComponent,
    TaskAssigneeComponent,
    TaskRoleComponent,
    TaskAlertComponent,
    TaskSelectorComponent,
    AddBoardDialogComponent,
    TaskManagerSupportListComponent,
    TaskManagerTicketListComponent,
    TaskManagerBoardListComponent,
    TaskManagerBoardTileComponent,
    TaskManagerKanbanComponent,
    TaskManagerPersonalKanbanComponent,
    TaskManagerSupportKanbanComponent,
    TaskManagerPersonalListComponent,
    TaskChecklistComponent,
    TaskSubTicketsComponent,
    TaskTitleComponent,
    TaskOccurrenceComponent,
    TaskChecklistItemAttachmentComponent,
    TaskCommentComponent,
    AddColumnDialogComponent,
    TaskCellViewerComponent,
    EditConversationListComponent,
    DeleteConversationsDialogComponent,
    ConversationAddContactComponent,
    ChatSettingsDialogComponent,
    HelpNotesComponent,
    SnippetComponent,
    TaskAutoCreateCellViewerComponent,
    TaskAlertSendNotificationNowGridComponent,
    ActivitiesComponent,
    ActivityFeedComponent,
    ActivityComponent,
    ActivityTrackerFilterComponent,
    ActivityFilterCountrySelectorComponent,
    ActivityFilterEntitySelectorComponent,
    ActivityFilterProjectSelectorComponent,
    ActivityFilterTransactionsSelectorComponent,
    ActivityFilterCaseSelectorComponent,
    ActivityFilterDateRangeSelectorComponent,
    ReferenceNotificationSettingsComponent,
    TaskComponent,
    TaskHeaderComponent,
    TaskBodyComponent,
    TaskToolbarComponent,
    TaskBodyDefaultViewComponent,
    TaskViewRightBarComponent,
    TaskSubTicketViewComponent,
    TaskDescriptionComponent,
    DumpDemoDataComponent,
    XatbotArticleCellViewerComponent
  ],
  providers: [

  ]})
export class TaskManagerModule {
  constructor(private activityTrackerHandler: ActivityTrackerHandler,
              private platformReportsHandler: PlatformReportsHandler,
              private commandService: CommandService,
              private activityTrackerViewHandler: ActivityTrackerViewHandler,
              private usageReportHandler: UsageReportHandler,
              private usageReportByArticleHandler: UsageReportByArticleHandler,
              private openTaskCommandHandler: OpenTaskCommandHandler,
              private demoConfigFilterCommandHandler: DemoConfigFilterCommandHandler,
              private supportOrbitaxHandler: SupportOrbitaxHandler,
              private showSelfRegisteredEatUsageReportHandler : ShowSelfRegisteredEatUsageReportHandler
  ) {
    TaskManagerDynamicComponentHelper.init();
    CollaborationDynamicComponentHelper.init();
    CollaborationDynamicComponentHelper.register('ActivityTrackerHandler', activityTrackerHandler);
    CollaborationDynamicComponentHelper.register('PlatformReportsHandler', platformReportsHandler);
    CollaborationDynamicComponentHelper.register('ActivityTrackerViewHandler', activityTrackerViewHandler);
    CollaborationDynamicComponentHelper.register('UsageReportHandler', usageReportHandler);
    CollaborationDynamicComponentHelper.register('UsageReportByArticleHandler', usageReportByArticleHandler);
    CollaborationDynamicComponentHelper.register('OpenTaskCommandHandler', openTaskCommandHandler);
    CollaborationDynamicComponentHelper.register('DemoConfigFilterCommandHandler', demoConfigFilterCommandHandler);
    CollaborationDynamicComponentHelper.register('SupportOrbitaxHandler', supportOrbitaxHandler);
    CollaborationDynamicComponentHelper.register('ShowSelfRegisteredEatUsageReportHandler', showSelfRegisteredEatUsageReportHandler);

    let command = new PlatformCommand('CreateActivityTrackerLinkCommand', 'CollaborationApi');
    this.commandService.registrPlatformLinkCommand('/activities', command);

    command = new PlatformCommand('CreateActivityTrackerViewCommand', 'CollaborationApi');
    this.commandService.registrPlatformLinkCommand('/activities/:type/:id', command);

    command = new PlatformCommand('SupportListToolLinkCommand', Api.TaskManager);
    command.fieldValues['ViewType'] = 'ListView';
    //this.commandService.registrPlatformLinkCommand('/task-manager/support/grid', command);

    command = new PlatformCommand('SupportListToolLinkCommand', Api.TaskManager);
    command.fieldValues['ViewType'] = 'CardView';
    //this.commandService.registrPlatformLinkCommand('/task-manager/support/card', command);

    //usage report old
    command = new PlatformCommand('CreateUsageReportLinkCommand', 'CollaborationApi');
    command.fieldValues['SelectedTabId'] = 'UsageReportByCompany';
    this.commandService.registrPlatformLinkCommand('/administration/usage-report-old', command);

    command = new PlatformCommand('CreateUsageReportLinkCommand', 'CollaborationApi');
    command.fieldValues['SelectedTabId'] = 'UsageReportByCompany';
    command.fieldValues['IsDemoReport'] = true;
    this.commandService.registrPlatformLinkCommand('/administration/usage-report-old/demo', command);

    command = new PlatformCommand('CreateUsageReportLinkCommand', 'CollaborationApi');
    command.fieldValues['SelectedTabId'] = 'UsageReport';
    this.commandService.registrPlatformLinkCommand('/administration/usage-report-old/by-user', command);

    command = new PlatformCommand('CreateUsageReportLinkCommand', 'CollaborationApi');
    command.fieldValues['SelectedTabId'] = 'UsageReport';
    command.fieldValues['IsDemoReport'] = true;
    this.commandService.registrPlatformLinkCommand('/administration/usage-report-old/demo/by-user', command);

    command = new PlatformCommand('CreateUsageReportLinkCommand', 'CollaborationApi');
    command.fieldValues['SelectedTabId'] = 'UsageReportBySandbox';
    this.commandService.registrPlatformLinkCommand('/administration/usage-report-old/sandbox', command);

    command = new PlatformCommand('CreateUsageReportLinkCommand', 'CollaborationApi');
    command.fieldValues['SelectedTabId'] = 'UsageReportByFeature';
    this.commandService.registrPlatformLinkCommand('/administration/usage-report-old/by-feature', command);

    command = new PlatformCommand('CreateUsageReportLinkCommand', 'CollaborationApi');
    command.fieldValues['SelectedTabId'] = 'UsageReportByFeature';
    command.fieldValues['IsDemoReport'] = true;
    this.commandService.registrPlatformLinkCommand('/administration/usage-report-old/demo/by-feature', command);

    command = new PlatformCommand('CreateUsageReportLinkCommand', 'CollaborationApi');
    command.fieldValues['SelectedTabId'] = 'UsageReportByArticle';
    this.commandService.registrPlatformLinkCommand('/administration/usage-report-old/by-article', command);

    command = new PlatformCommand('CreateUsageReportLinkCommand', 'CollaborationApi');
    command.fieldValues['SelectedTabId'] = 'UsageReportByArticle';
    command.fieldValues['IsDemoReport'] = true;
    this.commandService.registrPlatformLinkCommand('/administration/usage-report-old/demo/by-article', command);

    command = new PlatformCommand('CreateUsageReportLinkCommand', 'CollaborationApi');
    command.fieldValues['SelectedTabId'] = 'UsageReportByNewsletter';
    this.commandService.registrPlatformLinkCommand('/administration/usage-report-old/by-newsletter', command);

    command = new PlatformCommand('CreateUsageReportLinkCommand', 'CollaborationApi');
    command.fieldValues['SelectedTabId'] = 'UsageReportByDemo';
    command.fieldValues['IsDemoReport'] = true;
    this.commandService.registrPlatformLinkCommand('/administration/usage-report-old/demo/by-demo', command);

    // usage report new
    const usageReportToolLinkCommand = new PlatformCommand('UsageReportToolLinkCommand', Api.AdminPanel);
    this.commandService.registrPlatformLinkCommand('/administration/usage-report', usageReportToolLinkCommand);

    const platformCommand = new PlatformCommand('EntityCountUsageReportToolLinkCommand', Api.AdminPanel);
    this.commandService.registrPlatformLinkCommand('/administration/usage-report/entitycount', platformCommand);

    const detachedSubAccountsCommand = new PlatformCommand('DetachedSubAccountsUsageReportToolLinkCommand', Api.AdminPanel);
    this.commandService.registrPlatformLinkCommand('/administration/usage-report/detached-sub-accounts', detachedSubAccountsCommand);

    const hubspotToolLinkCommand = new PlatformCommand('HubSpotUsageReportToolLinkCommand', Api.AdminPanel);
    this.commandService.registrPlatformLinkCommand('/administration/usage-report/hubspot-report', hubspotToolLinkCommand);

    const xatbotFeedbackCommand = new PlatformCommand('XatbotFeedbackUsageReportToolLinkCommand', Api.AdminPanel);
    this.commandService.registrPlatformLinkCommand('/administration/usage-report/xatbot-feedback', xatbotFeedbackCommand);

    const xatbotArticleCommand = new PlatformCommand('XatbotArticleUsageReportToolLinkCommand', Api.AdminPanel);
    this.commandService.registrPlatformLinkCommand('/administration/usage-report/xatbot-article', xatbotArticleCommand)

    const xatbotUnresolvedCommand = new PlatformCommand('XatbotUnresolvedUsageReportToolLinkCommand', Api.AdminPanel);
    this.commandService.registrPlatformLinkCommand('/administration/usage-report/xatbot-unresolved', xatbotUnresolvedCommand);

    const xatbotActiveTrialCommand = new PlatformCommand('XatbotActiveTrialUsageReportToolLinkCommand', Api.AdminPanel);
    this.commandService.registrPlatformLinkCommand('/administration/usage-report/xatbot-active-trial', xatbotActiveTrialCommand);

    const xatbotExpiredTrialCommand = new PlatformCommand('XatbotExpiredTrialUsageReportToolLinkCommand', Api.AdminPanel);
    this.commandService.registrPlatformLinkCommand('/administration/usage-report/xatbot-expired-trial', xatbotExpiredTrialCommand);

    const xatbotLicensedUsersCommand = new PlatformCommand('XatbotLicensedUsersUsageReportToolLinkCommand', Api.AdminPanel);
    this.commandService.registrPlatformLinkCommand('/administration/usage-report/xatbot-licensed-users', xatbotLicensedUsersCommand);

    const xatbotCancelledUsersCommand = new PlatformCommand('XatbotCancelledUsersUsageReportToolLinkCommand', Api.AdminPanel);
    this.commandService.registrPlatformLinkCommand('/administration/usage-report/xatbot-cancelled-users', xatbotCancelledUsersCommand);

    const eatUsageReportByCompanyCommand = new PlatformCommand('EatUsageReportByCompanyToolLinkCommand', Api.AdminPanel);
    this.commandService.registrPlatformLinkCommand('/administration/usage-report/eat-usage-report-by-company', eatUsageReportByCompanyCommand);

    const eatUsagePerCompanyCommand = new PlatformCommand('EatUsagePerCompanyToolLinkCommand', Api.AdminPanel);
    this.commandService.registrPlatformLinkCommand('/administration/usage-report/eat-usage-report-by-company/:CompanyId', eatUsagePerCompanyCommand);

    this.registerPlatformLinkCommands(this.commandService);
  }

  private registerPlatformLinkCommands(commandService: CommandService) {
    commandService.registrPlatformLinkCommand('/administration/usage-report-old/by-article/:ArticleId',
      this.getPlatformLinkCommand('CreateUsageReportByArticleViewLinkCommand'));
    commandService.registrPlatformLinkCommand('/administration/usage-report-old/by-feature/:FeatureId',
      this.getPlatformLinkCommand('CreateUsageReportByFeatureViewLinkCommand'));
    commandService.registrPlatformLinkCommand('/administration/usage-report-old/by-company/:RowId',
      this.getPlatformLinkCommand('CreateUsageReportByCompanyViewLinkCommand'));
  }

  private getPlatformLinkCommand(commandName: string, api?: string) {
    const command = new PlatformCommand(commandName,  api ? api : 'CollaborationApi');
    return command;
  }
}
